import type {
    CoverableBaseDTO,
    CoverableDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';

const mockCoverableBaseDto: CoverableBaseDTO = {
    fixedId: '',
    flavourCode: '',
    flavourName: '',
    lobCode: '',
    isAddedInOnsa: true
};

const mockCoverables: CoverableDTO[] = [
    {
        ...mockCoverableBaseDto,
        flavourName: 'Hundforsikring',
        lobCode: 'pet',
        name: 'Hans Hansen',
        conditionExclusionManualTexts: [
            {
                name: 'Manual text title 1',
                publicID: 'pc:601',
                text: 'description text 1'
            },
            {
                name: 'Manual text title 2',
                publicID: 'pc:602',
                text: 'description text 2'
            }
        ],
        coverages: [
            {
                name: 'Afbestilling',
                terms: [
                    {
                        name: 'Afbestilling af rejser i Europa',
                        value: 'as'
                    },
                    {
                        name: 'Afbestilling af rejser i hele verden',

                        value: 'as'
                    }
                ],
                effectiveDate: {
                    year: 2023,
                    month: new Date().getMonth() + 1,
                    day: 17,
                    minutes_Top: 1,
                    hours_Top: 0
                },
                publicID: '12'
            },
            {
                name: 'Afbestilling',
                terms: [
                    {
                        name: 'Kost i forbindelse med leje af anden feriebolig',
                        value: '1.731,8068'
                    },
                    {
                        name: 'Overfald',
                        value: '577.612,7955'
                    }
                ],
                effectiveDate: {
                    year: 2023,
                    month: new Date().getMonth() - 1,
                    day: 14,
                    minutes_Top: 1,
                    hours_Top: 0
                },
                publicID: '13'
            }
        ],
        publicId: '302',
        fixedId: '302',
        monthlyPrice: { amount: 100, currency: 'dkk' },
        effectiveDate: {
            year: 2023,
            month: 6,
            day: 17,
            minutes_Top: 1,
            hours_Top: 0
        }
    },
    {
        ...mockCoverableBaseDto,
        lobCode: 'pet',
        flavourName: 'Petforsikring',
        name: 'Danmarksgadae 9, 2200 Kobenhaven N',
        coverages: [],
        publicId: '301',
        fixedId: '301',
        monthlyPrice: { amount: 100, currency: 'dkk' },
        effectiveDate: {
            year: 2023,
            month: 6,
            day: 17,
            minutes_Top: 1,
            hours_Top: 0
        }
    }
];

const mockSingleCoverablesDto: CoverableDTO = {
    ...mockCoverableBaseDto,
    flavourName: 'Hundforsikring',
    lobCode: 'pet',
    name: 'Hans Hansen',
    conditionExclusionManualTexts: [
        {
            name: 'Manual text title 1',
            publicID: 'pc:601',
            text: 'description text 1'
        },
        {
            name: 'Manual text title 2',
            publicID: 'pc:602',
            text: 'description text 2'
        }
    ],
    coverages: [
        {
            name: 'Afbestilling',
            terms: [
                {
                    name: 'Afbestilling af rejser i Europa',
                    value: 'as'
                },
                {
                    name: 'Afbestilling af rejser i hele verden',

                    value: 'as'
                }
            ],
            effectiveDate: {
                year: 2023,
                month: 1,
                day: 17,
                minutes_Top: 1,
                hours_Top: 0
            },
            publicID: '12'
        },
        {
            name: 'Afbestilling',
            terms: [
                {
                    name: 'Kost i forbindelse med leje af anden feriebolig',
                    value: '1.731,8068'
                },
                {
                    name: 'Overfald',
                    value: '577.612,7955'
                }
            ],
            effectiveDate: {
                year: 2023,
                month: new Date().getMonth() - 1,
                day: 14,
                minutes_Top: 1,
                hours_Top: 0
            },
            publicID: '13'
        }
    ],
    publicId: '302',
    fixedId: '302',
    monthlyPrice: { amount: 100, currency: 'dkk' },
    effectiveDate: {
        year: 2023,
        month: 6,
        day: 17,
        minutes_Top: 1,
        hours_Top: 0
    }
};

export { mockCoverables, mockCoverableBaseDto, mockSingleCoverablesDto };
